import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL, PAGE_INCLUSIONE_RICONGIUNGIMENTO, PAGE_RICONGIUNGIMENTO_COME_FUNZIONA } from 'types/url';

export const BreadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Ricongiungimento familiare',
    url: PAGE_INCLUSIONE_RICONGIUNGIMENTO,
  },
  {
    slash: 'VOGLIO SAPERE DI PIÙ SUL SERVIZIO',
    url: PAGE_RICONGIUNGIMENTO_COME_FUNZIONA,
  },
];

export const title = 'WeMi - Inclusione - Ricongiungimento familiare - Voglio sapere di più sul servizio';
export const description = 'Descrizione servizio ricongiungimento familiare';
export const keywords = 'welfare, milano, servizi, servizio, Ricongiungimento familiare, servizio ricongiungimento familiare,informazioni servizio ricongiungimento familiare';
